import { call, takeEvery, put, all } from 'redux-saga/effects';
import { fetchApiAuth } from '../utils/api';

import {
    getCompanyTagsRequest,
    getCompanyTagsSuccess,
    getCompanyTagsFailure,
    filterCompanyTagsSuccess,
    filterCompanyTagsFailure,
    createTagSuccess,
    createTagFailure,
    deleteTagSuccess,
    deleteTagFailure,
} from './companyTagActions';

const {
    GET_COMPANY_TAGS_REQUEST,
    FILTER_COMPANY_TAGS_REQUEST,
    CREATE_TAG_REQUEST,
    DELETE_TAG_REQUEST,
} = require('./companyTagActions').constants;

function* getCompanyTags(actions) {
    try {
        const { data } = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/tag/fetch-tags',
        });
        yield put(getCompanyTagsSuccess(data));
    } catch (error) {
        yield put(getCompanyTagsFailure(error));
    }
}

function* filterCompanyTags(action) {
    try {
        const url = action.payload && action.payload.page ? `tag/filter-tags?page=${action.payload.page}` : 'tag/filter-tags';
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url,
            body: action.payload,
        });
        yield put(filterCompanyTagsSuccess(response));
    } catch (error) {
        yield put(filterCompanyTagsFailure(error));
    }
}

function* createTag(name) {
    try {
        const { data } = yield call(fetchApiAuth, {
            method: 'POST',
            url: '/tag/store-tag',
            body: name,
        });
        yield put(createTagSuccess(data));
        yield put(getCompanyTagsRequest());
    } catch (error) {
        yield put(createTagFailure(error));
    }
}

function* deleteTag({ payload: id }) {
    try {
        yield call(fetchApiAuth, {
            method: 'GET',
            url: `/tag/delete/${id}`,
        });
        yield put(deleteTagSuccess(id));
    } catch (error) {
        yield put(deleteTagFailure(error));
    }
}

export default function* companyTagSaga() {
    yield all([
        takeEvery(GET_COMPANY_TAGS_REQUEST, getCompanyTags),
        takeEvery(FILTER_COMPANY_TAGS_REQUEST, filterCompanyTags),
        takeEvery(CREATE_TAG_REQUEST, createTag),
        takeEvery(DELETE_TAG_REQUEST, deleteTag),
    ]);
}
